import { render } from "./App.vue?vue&type=template&id=3534d65c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3534d65c&lang=less"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__